import {wealthManagementApiClient} from "./WealthManagementApiClient";

interface DuplicateNationalSampleOptions {
    readonly profileId: string;
    readonly isDuplicatingNationalSample: boolean;
    readonly setIsDuplicatingNationalSample: (isDuplicating: boolean) => void;
    readonly onSuccess: () => void;
}

export const duplicateNationalSample = async ({
    profileId,
    isDuplicatingNationalSample,
    setIsDuplicatingNationalSample,
    onSuccess,
}: DuplicateNationalSampleOptions): Promise<void> => {
    if (isDuplicatingNationalSample) return;

    setIsDuplicatingNationalSample(true);
    try {
        const result = await wealthManagementApiClient.duplicateNationalSample(profileId);
        if (result.isSuccessStatusCode) {
            onSuccess();
        }
    } catch (error) {
        console.error('Could not duplicate national sample', error);
    } finally {
        setIsDuplicatingNationalSample(false);
    }
};